import { render, staticRenderFns } from "./DatabaseManualRestore.vue?vue&type=template&id=1f59660c"
import script from "./DatabaseManualRestore.vue?vue&type=script&lang=js"
export * from "./DatabaseManualRestore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports